
import React, { useEffect, useState } from 'react';
import { Grid, Box, TextField, IconButton, Typography, Button, Accordion, AccordionSummary, AccordionDetails, Tooltip, Dialog, DialogTitle, DialogContent, Autocomplete } from '@mui/material';
import { Edit as EditIcon, ExpandMore } from '@mui/icons-material';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from 'lodash';
import { ACTION_TYPES, getStarlinkTerminalRouter, updateRouterConfig, getServicelineTerminalRouter, removeTerminalFromServiceLine, rebootTerminal, addTerminalToServiceLine } from '../slice';
import { toast } from 'react-toastify';
import close from "../../../asset/image/close.svg";
import "./DevicesTab.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ModalFooter from '../../../UserScreen/InventoryPage/InventorySettings/components/ModalFooter/ModalFooter';
import MenuBox from "./MenuPopup/MenuBox";


// dummy data
import {getRouterConfig, getRouterConfigs, getRebootRouter, assignRouterConfig, validateRouterConfig, updateRouterConfiguration, createRouterConfig, getRouterConfigVisibility } from "../slice";
import {WifiMap} from "./constants";
import DeleteWANProfileModal from '../../../UserScreen/InventoryPage/InventorySettings/components/Modals/DeleteProfileModal';
import AddEditInterfaceModal from '../../../UserScreen/InventoryPage/InventorySettings/components/Modals/AddEditInterfaceModal';
import EditRouterConfig from './Popup/EditRouterConfig';
import TerminalAndRouters from "./TerminalAndRouters";
import TerminalRouterInfo from "./TerminalRouterInfo";
import { DivIcon } from 'Leaflet.MultiOptionsPolyline';
import RouterRebootDialog from "../RouterConfig/RouterReebotDialog";
import AssignConfigDialog from "../RouterConfig/AssignConfigDialog";
import ReplaceConfigDialog from "../RouterConfig/ReplaceConfigDialog";
import DeleteConfigDialog from "../RouterConfig/DeleteConfigDialog";
import BypassDialog from "../RouterConfig/BypassDialog";
import CustomLoader from "../../Loader/CustomLoader";
import RebootTerminalDialog from './RebootTerminalDialog';

interface Terminal {
  device_id: string;
  name: string;
  starlinkId: string;
  serialNumber: string;
  kitNumber: string;
  softwareVersion: string;
  uptime: string;
  lastUpdated: string;
  publicIP: {
    ipv4: string;
    ipv6CPE: string;
    ipv6UE: string;
  };
  routers: Router[];
}

interface Router {
  router_id: string;
  router_device_id: string;
  wifi_hardware_version: string;
  wifi_software_version: string;
  wifi_uptime_s: string;
  last_bonded: string;
  name: string;
  clients: number;
  softwareVersion: string;
  hardwareVersion: string;
  connectionToStarlink: string;
  uptime: string;
  lastUpdated: string;
  splitBands: boolean;
  ssid: string;
  password: string;
}

type Config = {
  id: string;
  name: string;
};



const DevicesTab = (props) => {
    const { serviceLineToUpdate, getStarlinkTerminalRouter, gettingServicelineTerminalRouter, removeTerminalFromServiceLine, rebootTerminal, removeUserTerminalFromServiceLine, addTerminalToServiceLine, addUserTerminalToServiceLine, rebootUserTerminal, userTerminalData, getServicelineTerminalRouter, 
        applyRouterConfig, updatingRouterConfig, updateRouterConfig, getRouterConfig, getRouterConfigs, routerConfig, routerConfigs, routersOnTerminal, servicelineTerminalRouters, gettingTerminalRouter, getRebootRouter, rebootRouter, assignRouterConfig, validateRouterConfig, updateRouterConfiguration, createRouterConfig, routerConfigurationUpdate, routerConfigAssign, createNewRouterConfig, routerConfigVisibility, getRouterConfigVisibility } = props;
    const dispatch = useDispatch();
    const pendingAutoAssignRef = React.useRef(false);
    const [split, setSplit] = useState(false);
    const [userTerminals, setUserTerminals] = useState([])
    const [selectedTerminal, setSelectedTerminal] = useState<any>({})
    const [selectedRouter, setSelectedRouter] = useState<any>(null);
    const [isEditing, setIsEditing] = useState<any>(false);
    const [editedData, setEditedData] = useState<Record<number, { ssid: string, password: string, band: string }>>({});
    const [bypassState, setBypassState] = useState(selectedRouter?.wifi_is_bypassed_str === "true");
    const [basicServiceSets, setBasicServiceSets] = useState<any>([])

    const [terminalData, setTerminalData] = useState<any>([])
    const [selectedTrml, setSelectedTrml]  = useState("");
    const [selectedRutrTrmnl, setSelectedRutrTrmnl] = useState("");
    const [selectedRutr, setSelectedRutr] = useState<any>({});
    const [isTerminalSelected, setIsTeminalSelected] = useState(true);
    const [isRouterSelected, setIsRouterSelected] = useState(false);
    const [deviceInfoExpanded, setDeviceInfoExpanded] = useState(true);
    const [networkInfoExpanded, setNetworkInfoExpanded] = useState(false);
    const [configExpanded, setConfigExpanded] = useState(false);
    const [assignedConfig, setAssignedConfig] = useState<any>();
    const [configs, setConfigs] = useState<any>([]);
    const [selectedConfig, setSelectedConfig] = useState<any>({});
    const [assignedConfigMenu, setAssignedConfigMenu] = useState(false);
    const [selectedWifiSec, setSelectedWifiSec] = useState({});
    const [libraryConfigMenu, setLibraryConfigMenu] = useState(false);
    const [bypassOpen, setBypassOpen] = useState(false);
    const [byPassMode, setBypassMode] = useState(selectedRutr?.wifi_is_bypassed === "true");
    const [rebootOpen, setRebootOpen] = useState(false);
    const [assignConfigOpen, setAssignConfigOpen] = useState(false);
    const [addNewConfig, setAddNewConfig] = useState(false);
    const [deleteConfigOpen, setDeleteConfigOpen] = useState(false);
    const [editConfigOpen, setEditConfigOpen] = useState(false);
    const [splitBands, setSplitBands] = useState(true);
    const [starlinkWifiSettingsExpanded, setStarlinkWifiSettingsExpanded] = useState(false);
    const [generalExpanded, setGeneralExpanded] =  useState(true);
    const [networkExpanded, setNetworkExpanded] = useState(false);
    const [networkOptionsExpanded, setNetworkOptionsExpanded] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [confirmReboot, setConfirmReboot] = useState(false)
    const [openAddToServiceLinePopup, setOpenAddToServiceLinePopup] = useState(false)
    const [filteredTerminalArray, setFilteredTerminalArray] = useState<any>([])
    const [selectedTerminals, setSelectedTerminals] = useState<any>(null);
    const [addTerminalDialog, setAddTerminalDialog] = useState(false)
    const [dhcpExpanded, setDhcpExpanded] = useState(false);
    const [ethernet, setEthernet] = useState(false);
    const [originalRouterConfig, setOriginalRouterConfig] = useState<any>({});
    const [ethernetIndexes, setEthernetIndexes] = useState<number[]>([]);
    const [libraryMenuOptions, setLibraryMenuOptions] = useState([{label: "Edit", isSelected: false}]);
    const [assignedConfigMenuOptions, setAssignedConfigMenuOptions] = useState([{label: "Edit", isSelected: false}])
    const [newConfig, setNewConfig] = useState(false);

    useEffect(() => {
        if (serviceLineToUpdate) {
            setUserTerminals(serviceLineToUpdate?.userTerminalDetails)
            setSelectedTerminal(serviceLineToUpdate?.userTerminalDetails && serviceLineToUpdate?.userTerminalDetails?.length > 0 && serviceLineToUpdate?.userTerminalDetails[0])
            getStarlinkTerminalRouter({ userTerminalId: serviceLineToUpdate?.userTerminalDetails && serviceLineToUpdate?.userTerminalDetails?.length > 0 && serviceLineToUpdate?.userTerminalDetails[0]?.userTerminalId })
            getServicelineTerminalRouter({ serviceLineNumber: serviceLineToUpdate?.serviceLineNumber })
            if (serviceLineToUpdate?.accountDpId) {
                getRouterConfigVisibility({ dpId: serviceLineToUpdate.dpId });
            }
        }
    }, [serviceLineToUpdate])

    const handleChangeTerminal = (e) => {
        let terminal = e.target.value;
        setSelectedTerminal(terminal)
        getStarlinkTerminalRouter({ userTerminalId: terminal?.userTerminalId })
    }

    useEffect(() => {
        setSelectedRouter(null)
        if (routersOnTerminal?.length > 0) {
            setSelectedRouter(routersOnTerminal[0]);
            setTerminalData(prev => {
                if (!prev?.length) return prev;
                const updated = [...prev];
                updated[0] = {
                    ...updated[0],
                    routers: routersOnTerminal.map(r => ({
                        ...r,
                        router_device_id: r.device_id,
                        router_id: r.device_id,
                        wifi_is_bypassed: r.wifi_is_bypassed_str,
                    })),
                };
                return updated;
            });
        }
    }, [routersOnTerminal]);

    useEffect(() => {
        if (servicelineTerminalRouters?.length > 0) {
            const converted = servicelineTerminalRouters.map((item) => ({
                ...item,
                routers: item?.routers_array ? JSON.parse(item.routers_array) : [],
            }));
            setTerminalData(converted);
            setSelectedTrml(servicelineTerminalRouters[0].device_id)
        }
    }, [servicelineTerminalRouters]);

    const handleChangeRouter = (event) => {
        const selectedDeviceId = event.target.value;
        const selected = routersOnTerminal.find(router => router.device_id === selectedDeviceId);
        setSelectedRouter(selected);
    };

    const convertSeconds = (input) => {
        let seconds = parseInt(input, 10);
        if (isNaN(seconds) || seconds < 0) {
            return "Invalid input.";
        }
        const days = Math.floor(seconds / (60 * 60 * 24));
        seconds %= 60 * 60 * 24;
        const hours = Math.floor(seconds / (60 * 60));
        seconds %= 60 * 60;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;

        let result = "";
        if (days > 0) result += `${days}D `;
        if (hours > 0) result += `${hours}H `;
        if (minutes > 0) result += `${minutes}M `;
        if (seconds > 0 || result === "") result += `${seconds}S`;

        return result.trim();
    }

    const saveNetworkSettings = (ssid: string, password: string, band: string, networkIndex: number, bssIndex: number, config_id: any) => {
        try {
            let networks;

            const parsedNetworks = selectedRouter?.networks
            ? JSON.parse(selectedRouter.networks)
            : [];

        if (parsedNetworks[0]?.basicServiceSets?.length === 2 && split) {
                networks = Object.values(editedData).map(({ ssid, password, band }) => ({  band, ssid, password }));
            } else if (parsedNetworks[0]?.basicServiceSets?.length === 2 && !split) {
                const values = Object.values(editedData);
                const { ssid, password } = values[0];
                    networks = values.map(({ band }) => ({   band,     ssid, password, }));
            } else if (parsedNetworks[0]?.basicServiceSets?.length === 1 && split) {
                    networks = Object.values(editedData).map(({ ssid, password, band }) => ({band,ssid,password}));
            } else {
                    networks = Object.values(editedData).map(({ ssid, password, band }) => ({  band,  ssid, password   }));
            }

            const payload = {
                organizationId: serviceLineToUpdate?.accountDpId,
                accountNumber: serviceLineToUpdate?.accountNumber,
                userTerminalId: selectedTerminal?.userTerminalId,
                networks: networks,
                applyBypassMode: selectedRouter?.wifi_is_bypassed_str === "false" ? false : true,
                configId: config_id,
            };

            updateRouterConfig(payload);
        } catch (error) {
            toast.error("Failed to update Router Config");
        }
    };

    useEffect(() => {
        if (!_.isEmpty(applyRouterConfig)) {
            setIsEditing(null);
            getStarlinkTerminalRouter({ userTerminalId: serviceLineToUpdate?.userTerminalDetails && serviceLineToUpdate?.userTerminalDetails?.length > 0 && serviceLineToUpdate?.userTerminalDetails[0]?.userTerminalId })
            dispatch({ type: ACTION_TYPES.APPLY_ROUTER_CONFIG, payload: null });
        }
    }, [applyRouterConfig])

    const handleToggleBypass = (value) => {
    
            try {
                setBypassState(value);
    
                const payload = {
                    organizationId: serviceLineToUpdate?.accountDpId,
                    accountNumber: serviceLineToUpdate?.accountNumber,
                    userTerminalId: selectedTerminal?.userTerminalId,
                    applyBypassMode: value,
                    configId: selectedRouter?.config_id,
                };
                updateRouterConfig(payload);
            } catch (err) {
                setBypassState(!value);
            }
        };

    useEffect(() => {
        try {
            const parsedNetworks = selectedRouter?.networks
                ? JSON.parse(selectedRouter.networks)
                : [];

            const hasMultipleBSS = parsedNetworks[0]?.basicServiceSets?.length > 1;

            if (parsedNetworks && parsedNetworks?.length > 0) {
                setBasicServiceSets(parsedNetworks[0]?.basicServiceSets || [])
            }
            setSplit(!!hasMultipleBSS);
        } catch (error) {
            setSplit(false);
        }
    }, [selectedRouter]);

    const handleEditClick = (network, netIndex) => {
        const newEditedData: Record<number, { ssid: string, password: string, band: string }> = {};
        network.basicServiceSets.forEach((bss, idx) => {
            newEditedData[idx] = {
                ssid: bss?.ssid || '',
                password: bss?.authWpa2?.password || '',
                band: bss?.band || ''
            };
        });
        setEditedData(newEditedData);
        setIsEditing(!isEditing);
    };

    const handleChangeSplit = (event) => {
        const newValue = event.target.checked;
        setSplit(newValue)

        const parsedNetworks = selectedRouter?.networks
            ? JSON.parse(selectedRouter.networks)
            : [];

        if (parsedNetworks[0]?.basicServiceSets) {
            if (newValue) {
                if (parsedNetworks[0]?.basicServiceSets?.length === 1) {
                    setBasicServiceSets([parsedNetworks[0]?.basicServiceSets[0], parsedNetworks[0]?.basicServiceSets[0]])
                } else if (parsedNetworks[0]?.basicServiceSets?.length === 2) {
                    setBasicServiceSets(parsedNetworks[0]?.basicServiceSets)
                }
            } else {
                setBasicServiceSets([parsedNetworks[0]?.basicServiceSets[0]])
            }
        }
    }

    useEffect(() => {
        if(routerConfig?.data?.data?.routerConfigJson){
            const rawRouterConfig = routerConfig.data.data.routerConfigJson;
            const parsedData = {
                ...routerConfig.data.data,
                routerConfigJson:
                    typeof rawRouterConfig === "string"
                        ? JSON.parse(rawRouterConfig)
                        : rawRouterConfig
            };

            setAssignedConfig(parsedData);
            if(deviceInfoExpanded){
                setSelectedConfig(parsedData);
                const newIndexes = parsedData.routerConfigJson.networks
                    .map((network, index) => (Object.keys(network).length === 0 ? index : null))
                    .filter((idx) => idx !== null) as number[];

                setEthernetIndexes(newIndexes);
            }
        }
        else setAssignedConfig({});
    }, [routerConfig, deviceInfoExpanded])

    useEffect(()=> {
        if(routerConfigs?.data?.data.results){
            const results = routerConfigs?.data?.data?.results ?? [];
            const parsedResults = results.map(item => ({
            ...item,
            routerConfigJson: item.routerConfigJson 
                ? JSON.parse(item.routerConfigJson) 
                : null
            }));
            setConfigs(parsedResults)
        }
    },[routerConfigs])

    const [expanded, setExpanded] = useState<Record<string, boolean>>({});

    const toggleExpand = (id: string) => {
        setExpanded((prev) => ({
        ...prev,
        [id]: !prev[id],
        }));
    };

    const handlePlusClick = () => {

    }

    const handleAssignClick = (config) => {
        setAssignConfigOpen(true);
        setSelectedConfig(config);
        const newIndexes = config.routerConfigJson.networks
            .map((network, index) => (Object.keys(network).length === 0 ? index : null))
            .filter((idx) => idx !== null) as number[];

        setEthernetIndexes(newIndexes);
    }

    const handleAssignConfigClose = () => {
        setAssignConfigOpen(false);
        setSelectedConfig({});
        setEthernetIndexes([]);
    }
    const handleAssignConfigConfirm = () => {
        const parameters={
            organizationId: serviceLineToUpdate?.accountDpId,
            accountNumber: serviceLineToUpdate?.accountNumber,
            routerId: selectedRutr?.router_id,
            configId: selectedConfig?.configId
        }
        assignRouterConfig(parameters);
        handleAssignConfigClose();
    }
    const handleterminalClick = (value) => {
        setSelectedTrml(value);
        setIsTeminalSelected(true);
        setIsRouterSelected(false);
    }
    const handleRouterClick = (router, terminalId) => {
        setSelectedRutrTrmnl(terminalId);
        setSelectedRutr(router);
        setIsTeminalSelected(false);
        setIsRouterSelected(true);
        setBypassMode(router?.wifi_is_bypassed=="true");
        const parameters1={
            organizationId: serviceLineToUpdate.accountDpId,
            accountNumber: serviceLineToUpdate.accountNumber,
            configId: router.config_id ?? ""
        }
        const parameters2={
            organizationId: serviceLineToUpdate.accountDpId,
            accountNumber: serviceLineToUpdate.accountNumber,
        }
        getRouterConfig(parameters1);
        getRouterConfigs(parameters2);
    }
    const handleDeviceInfoAccordionChange = () => {
        setDeviceInfoExpanded(!deviceInfoExpanded);
        if(!deviceInfoExpanded){
            setConfigExpanded(false);
        }
        else{
            setConfigExpanded(true);
        }
        setNetworkInfoExpanded(false);
    }
    const handleNetworkInfoAccordianChange = () => {
        setNetworkInfoExpanded(!networkInfoExpanded);
        if(!networkInfoExpanded){
            setDeviceInfoExpanded(false);
        }
        else{
            setDeviceInfoExpanded(true);
        }
        setConfigExpanded(false);
    }
    const handleConfigAccordionChange = () => {
        setConfigExpanded(!configExpanded);
        if(!configExpanded){
            setDeviceInfoExpanded(false);
        }
        else{
            setDeviceInfoExpanded(true);
        }
        setNetworkInfoExpanded(false);
    }

    const handleAssignedConfigClick = (config) => {
        setSelectedConfig(config);
        setOriginalRouterConfig(config);
        setAssignedConfigMenu(true);
        const newIndexes = config?.routerConfigJson.networks
            .map((network, index) => (Object.keys(network).length === 0 ? index : null))
            .filter((idx) => idx !== null) as number[];

        setEthernetIndexes(newIndexes);
    }
    const handleLibraryMenuClick = (config) => {
        setSelectedConfig(config);
        setOriginalRouterConfig(config);
        setLibraryConfigMenu(true);
        const newIndexes = config.routerConfigJson.networks
            .map((network, index) => (Object.keys(network).length === 0 ? index : null))
            .filter((idx) => idx !== null) as number[];

        setEthernetIndexes(newIndexes);
    }
    const [copied, setCopied] = useState(false);
    const handleCopy = async () => {
        if (selectedConfig?.configId) {
        await navigator.clipboard.writeText(selectedConfig.configId.toString());
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // reset tooltip
        }
    };
    const handleAssignedConfigMenuClose = () => {
        setAssignedConfigMenu(false);
        // setSelectedConfig({});
        // setEthernetIndexes([]);
        // setOriginalRouterConfig({});
    }
    const handleLibraryMenuClose = () => {
        setLibraryConfigMenu(false);
        // setSelectedConfig({});
        // setEthernetIndexes([]);
        // setOriginalRouterConfig({});
        setLibraryMenuOptions((prev) =>
            prev.map((opt) => (
                { ...opt, isSelected: false }
            )
        ));
    }
    const handleBypassClick = () => {
        setBypassOpen(true);
        setSelectedConfig((prev) => {
            const updatedConfig = { ...prev.routerConfigJson };
            updatedConfig["bypassMode"] = true;
            return {
                ...prev,
                routerConfigJson: updatedConfig,
            };
        });
    }
    const handleRebootClick = () => {
        setRebootOpen(true);
    }
    const handleBypassClose = () => {
        setSelectedConfig((prev) => {
            const updatedConfig = { ...prev.routerConfigJson };
            delete updatedConfig["bypassMode"];
            return {
                ...prev,
                routerConfigJson: updatedConfig,
            };
        });
        setBypassOpen(false);
    }
    const handleBypassConfirm = () => {
        handleSave();
        setBypassOpen(false);
    }
    const handleRebootClose = () => {
        setRebootOpen(false)
    }
    const handleRebootConfirm = () => {
        const parameters= {
            organizationId: serviceLineToUpdate.accountDpId,
            accountNumber: serviceLineToUpdate.accountNumber,
            routerId: selectedRutr.router_id
        }
        getRebootRouter(parameters);
        handleRebootClose();
    }


    const handleAddNewConfig = () => {
        setAddNewConfig(true);
    }
    const handleNewConfigClose = () => {

    }
    const handleDeleteConfigClose = () => {
        setDeleteConfigOpen(false);
    }
    const handleDeleteConfigConfirm = () => {

    }
    const handleDeleteConfigClick = () => {
        setDeleteConfigOpen(true);
    }
    const handleConfigureClick = () => {
        setSelectedConfig(_.cloneDeep(assignedConfig));
        const newIndexes = assignedConfig.routerConfigJson.networks
            .map((network, index) => (Object.keys(network).length === 0 ? index : null))
            .filter((idx) => idx !== null) as number[];
        setEthernetIndexes(newIndexes);
        setOriginalRouterConfig(_.cloneDeep(assignedConfig));
        setEditConfigOpen(true);
    }
    const handleEditConfigClick = () => {
        setEditConfigOpen(true);
    }
    const handleAssignedConfigMenuSelection = (label: string) => {
        setAssignedConfigMenuOptions((prev) => 
            prev.map((opt) =>
                opt.label === label ? { ...opt, isSelected: true } : { ...opt, isSelected: false }
            )
        );
        switch(label) {
            case "Edit":
                handleEditConfigClick();
                break;
            default:
                break;
        }
    }
    const handleLibraryMenuSelectOption = (label: string) => {
        setLibraryMenuOptions((prev) =>
            prev.map((opt) =>
                opt.label === label ? { ...opt, isSelected: true } : { ...opt, isSelected: false }
            )
        );
        switch (label) {
            case "Edit":
                handleEditConfigClick();
                break;
            default:
                break;
        }
    };
    const handleEditConfigClose = () => {
        setEditConfigOpen(false);
        setAssignedConfigMenu(false);
        setLibraryConfigMenu(false);
        setSelectedConfig({});
        setOriginalRouterConfig({});
        setNewConfig(false);
        setLibraryMenuOptions((prev) =>
            prev.map((opt) => (
                { ...opt, isSelected: false }
            ))
        );
        setAssignedConfigMenuOptions((prev) =>
            prev.map((opt) => (
                { ...opt, isSelected: false }
            ))
        );
    }
    const handleStarlinkWifiAccordionChange = () => {
        setStarlinkWifiSettingsExpanded(!starlinkWifiSettingsExpanded);
    }
    const handleNetworkAccordionChange = () => {
        setNetworkExpanded(!networkExpanded);
    }
    const handleNetworkOptionsAccordionChange = () => {
        setNetworkOptionsExpanded(!networkOptionsExpanded);
    }
    const handleDHCPAccordionChange = () => {
        setDhcpExpanded(!dhcpExpanded);
    }
    // const handleCancel = () => {
    //     if(routerConfig?.data?.data?.routerConfigJson){
    //         const parsedData = {
    //             ...routerConfig?.data?.data,
    //             routerConfigJson: JSON.parse(routerConfig?.data?.data?.routerConfigJson)
    //         };
    //         setSelectedConfig(_.cloneDeep(parsedData));
    //         const newIndexes = parsedData.routerConfigJson.networks
    //             .map((network, index) => (Object.keys(network).length === 0 ? index : null))
    //             .filter((idx) => idx !== null) as number[];

    //         setEthernetIndexes(newIndexes);
    //         setOriginalRouterConfig(_.cloneDeep(parsedData));
    //     }
    // }

    const handleGeneralAccordionChange = () => {
        setGeneralExpanded(!generalExpanded);
    }
    const handleNetworkNameChange = (value:string, networkIndex: number, bssIndex?: number) => {
        setSelectedConfig((prev) => {
            const updated = { ...prev };
            const bssArray = updated.routerConfigJson?.networks?.[networkIndex]?.basicServiceSets;
            if (!bssArray) return prev;
            if (typeof bssIndex === "number") {
            bssArray[bssIndex] = { ...bssArray[bssIndex], ssid: value };
            } else {
            updated.routerConfigJson.networks[networkIndex].basicServiceSets = bssArray.map((bss) => ({
                ...bss,
                ssid: value
            }));
            }
            return updated;
        });
    }
    const handleNetworkPasswordChange = (value:string, networkIndex: number, config_key) => {
        setSelectedConfig((prev) => {
            const updated = { ...prev };
            const bssArray =
            updated.routerConfigJson?.networks?.[networkIndex]?.basicServiceSets;

            if (!bssArray) return prev;

            updated.routerConfigJson.networks[networkIndex].basicServiceSets =
            bssArray.map((bss) => {
                if (bss[config_key]) {
                return {
                    ...bss,
                    [config_key]: { password: value },
                };
                }
                return bss;
            });

            return updated;
        });
    }
    const handleSaveEnable = () => {
        // if (_.isEqual(selectedConfig, originalRouterConfig)) {
        //     return false;
        // }
        if (!selectedConfig?.nickname && !selectedConfig?.configId) {
            return false;
        }
        return selectedConfig?.routerConfigJson?.networks?.every((network, networkIndex) => {
            if (ethernetIndexes.includes(networkIndex)) {
                return true;
            }
            if (!Array.isArray(network.basicServiceSets) || network.basicServiceSets.length === 0) {
                return false;
            }
            return network.basicServiceSets.every((bss) => {
                if (!bss?.ssid || bss.ssid.trim() === "" || bss.ssid.trim().length > 32) {
                    return false;
                }
                const authKey = Object.keys(bss).find((key) =>
                    key.toLowerCase().startsWith("auth")
                );
                const authObj = authKey ? bss[authKey] : null;

                if (!authKey || !authObj || typeof authObj !== "object") {
                    return false;
                }
                if ( authKey == "authOpen" || authKey == "authOpenEncrypted") {
                    return true;
                }
                if (!("password" in authObj)) {
                    return false;
                }

                const password = authObj.password;
                if (!password || password.length < 8 || password.length > 32) {
                    return false;
                }

                return true;
            }) ?? false;
        })
    }
    const handleAddNewClick = () => {
        setNewConfig(true);
        setSelectedConfig({});
        setEditConfigOpen(true);
        setEthernetIndexes([]);
    }
    const handleSave = () => {
        const parameters={
            organizationId: serviceLineToUpdate?.accountDpId,
            accountNumber: serviceLineToUpdate?.accountNumber,
            configName: selectedConfig.nickname,
            configId: selectedConfig.configId,
            configJson: {
                ...selectedConfig.routerConfigJson,
                networks: selectedConfig.routerConfigJson.networks.map((network, idx) =>
                    ethernetIndexes.includes(idx) ? {} : network
                ),
            }
        }
        
        if(newConfig){
            if (routerConfigVisibility === 'disabled') {
                pendingAutoAssignRef.current = true;
            }
            createRouterConfig(parameters);
        }
        else{
            if(parameters?.configId){
            updateRouterConfiguration(parameters);
            }
        }
        setEditConfigOpen(false);
        setAssignedConfigMenu(false);
        setLibraryConfigMenu(false);
        setNewConfig(false);
    }

    useEffect(() => {
        if (isRouterSelected){
            const parameters1={
                organizationId: serviceLineToUpdate.accountDpId,
                accountNumber: serviceLineToUpdate.accountNumber,
                configId: selectedRutr.config_id
            }
            const parameters2={
                organizationId: serviceLineToUpdate.accountDpId,
                accountNumber: serviceLineToUpdate.accountNumber,
            }
            getRouterConfig(parameters1);
            getRouterConfigs(parameters2);
        }
        if (pendingAutoAssignRef.current && createNewRouterConfig?.data?.configId) {
            pendingAutoAssignRef.current = false;
            assignRouterConfig({
                organizationId: serviceLineToUpdate?.accountDpId,
                accountNumber: serviceLineToUpdate?.accountNumber,
                routerId: selectedRutr?.router_id,
                configId: createNewRouterConfig?.data?.configId
            });
        }
    },[routerConfigurationUpdate, routerConfigAssign, createNewRouterConfig])

    const handleRemoveServiceLine = (ut) => {
        let params = {
            organizationId: serviceLineToUpdate?.accountDpId,
            accountNumber: serviceLineToUpdate?.accountNumber,
            serviceLineNumber: serviceLineToUpdate?.serviceLineNumber,
            userTerminalId: ut
        }
        removeTerminalFromServiceLine(params)
    }

    useEffect(() => {
        if (!_.isEmpty(removeUserTerminalFromServiceLine)) {
            toast.success(`User Terminal removed successfully.`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })

            // let updatedTerminalArray = terminalData?.filter((userTerminal) => {
            //     return userTerminal.device_id !== selectedTrml
            // })
            // setTerminalData(updatedTerminalArray)
            getServicelineTerminalRouter({serviceLineNumber: serviceLineToUpdate?.serviceLineNumber});
            setConfirmDelete(false)

            dispatch({ type: ACTION_TYPES.REMOVE_USER_TERMINAL_FROM_SERVICE_LINE, payload: {} })
        }

    }, [removeUserTerminalFromServiceLine])

     useEffect(() => {
          if (Array.isArray(userTerminalData?.user_terminals)) {
            const filteredTerminals = userTerminalData.user_terminals.reduce((acc: any[], item: any) => {
            if (item?.account_number === serviceLineToUpdate?.accountNumber) {
                acc.push({
                    dishSerialNumber: item?.dish_serial_number,
                    kitSerialNumber: item?.kit_serial_number,
                    userTerminal: item?.user_terminal_id,
                    accountNumber: item?.account_number
                });
            }
            return acc;
        }, []);
    
        setFilteredTerminalArray(filteredTerminals);
    }
        }, [userTerminalData])

        const handleRebootTerminal = (ut, notes: string) =>{
    
            let params = {
                organizationId: serviceLineToUpdate?.accountDpId,
                accountNumber: serviceLineToUpdate?.accountNumber,
                userTerminalId:   ut,
                notes: notes
            }
            rebootTerminal(params)
        }
    
        useEffect(() => {
            if (!_.isEmpty(rebootUserTerminal)) {
                toast.success(`User Terminal rebooted successfully.`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                })
               setConfirmReboot(false)
                dispatch({ type: ACTION_TYPES.REBOOT_USER_TERMINAL, payload: {} })
            }
    
        }, [rebootUserTerminal])

        const layout =  [
              {
                columns: [
                  {
                    component: (
                      <Typography variant="body2" className="starlink-terminal-add-text">
                        Associate Terminals to Service Line
                      </Typography>
                    ),
                  },
                ],
              },
              {
                columns: [
                  {
                        component: (
                            <Autocomplete
                                disableClearable
                                fullWidth
                                options={filteredTerminalArray}
                                getOptionLabel={(option) => `${option?.userTerminal || ''} - ${option?.kitSerialNumber || ''} - ${option?.dishSerialNumber || ''}`}
                                value={selectedTerminals}
                                onChange={(event, newValue) => {
                                    setSelectedTerminals(newValue)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                    />
                                )}
                            />
                        ),
                  },
                ],
              },
              
            ]

        
            const handleAddUserTerminal = () => {
                let params = {
                    organizationId: serviceLineToUpdate?.accountDpId,
                    accountNumber: serviceLineToUpdate?.accountNumber,
                    serviceLineNumber: serviceLineToUpdate?.serviceLineNumber,
                    userTerminalId: selectedTerminals?.userTerminal
                }
                addTerminalToServiceLine(params)
            }
        
            useEffect(() => {
                if (!_.isEmpty(addUserTerminalToServiceLine)) {
                    toast.success(`User Terminal added successfully.`, {
                        position: toast.POSITION.BOTTOM_LEFT,
                    })
                    // let newTerminal:any = terminalData
                    // newTerminal.push({
                    //     kitSerialNumber: selectedTerminals?.kitSerialNumber,
                    //     userTerminalId: selectedTerminals?.userTerminal
                    // })
                    // setTerminalData(newTerminal)
                    getServicelineTerminalRouter({serviceLineNumber: serviceLineToUpdate?.serviceLineNumber});
                    setSelectedTerminals(null)
                    setOpenAddToServiceLinePopup(false)
                    dispatch({ type: ACTION_TYPES.ADD_USER_TERMINAL_TO_SERVICE_LINE, payload: {} })

                }
        
            }, [addUserTerminalToServiceLine])

    return(
        <div>
            <div className="devicesTabContainer">
                <div className="deviceTab">
                    {gettingServicelineTerminalRouter ? (
                            <CustomLoader
                              showLoader={true}
                              loadingText={"Please wait..."}
                            />
                          ) : null}
                    <TerminalAndRouters terminalData={terminalData} setTerminalData={setTerminalData} handleterminalClick={handleterminalClick} isTerminalSelected={isTerminalSelected} isRouterSelected={isRouterSelected} selectedTrml={selectedTrml} handleRouterClick={handleRouterClick} selectedRutr={selectedRutr} setOpenAddToServiceLinePopup={setOpenAddToServiceLinePopup}/>
                    <TerminalRouterInfo terminalData={terminalData} isTerminalSelected={isTerminalSelected} selectedTrml={selectedTrml} serviceLineToUpdate={serviceLineToUpdate} handlePlusClick={handlePlusClick} isRouterSelected={isRouterSelected} selectedRutr={selectedRutr} selectedRutrTrmnl={selectedRutrTrmnl}
                        handleBypassClick={handleBypassClick} handleRebootClick={handleRebootClick} deviceInfoExpanded={deviceInfoExpanded} handleDeviceInfoAccordionChange={handleDeviceInfoAccordionChange} assignedConfig={assignedConfig} splitBands={splitBands}
                        configExpanded={configExpanded} handleConfigAccordionChange={handleConfigAccordionChange} handleAssignedConfigClick={handleAssignedConfigClick} configs={configs} selectedConfig={selectedConfig} handleAssignClick={handleAssignClick} handleLibraryMenuClick={handleLibraryMenuClick}
                        setConfirmDelete={setConfirmDelete} setConfirmReboot={setConfirmReboot} handleEditConfigClick={handleEditConfigClick} networkInfoExpanded={networkInfoExpanded} handleNetworkInfoAccordianChange={handleNetworkInfoAccordianChange} handleConfigureClick={handleConfigureClick} handleAddNewClick={handleAddNewClick}
                        configVisibility={routerConfigVisibility}
                    />
                    <BypassDialog bypassOpen={bypassOpen} handleBypassClose={handleBypassClose} handleBypassConfirm={handleBypassConfirm} byPassMode={byPassMode}/>
                    <RouterRebootDialog rebootOpen={rebootOpen} handleRebootClose={handleRebootClose} handleRebootConfirm={handleRebootConfirm}/>
                    <AssignConfigDialog assignConfigOpen={assignConfigOpen} assignedConfig={assignedConfig} handleAssignConfigClose={handleAssignConfigClose} handleAssignConfigConfirm={handleAssignConfigConfirm} selectedConfig={selectedConfig}/>
                    <ReplaceConfigDialog assignConfigOpen={assignConfigOpen} assignedConfig={assignedConfig} handleAssignConfigClose={handleAssignConfigClose} handleAssignConfigConfirm={handleAssignConfigConfirm} selectedConfig={selectedConfig}/>
                    <DeleteConfigDialog deleteConfigOpen={deleteConfigOpen} handleDeleteConfigClose={handleDeleteConfigClose} handleDeleteConfigConfirm={handleDeleteConfigConfirm}/>

                    <MenuBox menuOpen={assignedConfigMenu} handleMenuClose={handleAssignedConfigMenuClose} title={"Config ID"} showClose={true} copyItem={selectedConfig.configId} options={assignedConfigMenuOptions} handleSelectOption={handleAssignedConfigMenuSelection} top={"275px"} right={"38px"} addNewButton={true} addNewName={"+ Add New Config"} handleAddNewClick={handleAddNewClick}/>
                    <MenuBox menuOpen={libraryConfigMenu} handleMenuClose={handleLibraryMenuClose} title={"Config ID"} showClose={true} copyItem={selectedConfig.configId} options={libraryMenuOptions} handleSelectOption={handleLibraryMenuSelectOption} top={"320px"} right={"40px"} addNewButton={true} addNewName={"+ Add New Config"} handleAddNewClick={handleAddNewClick}/>
                    <EditRouterConfig editConfigOpen={editConfigOpen} handleEditConfigClose={handleEditConfigClose} selectedConfig={selectedConfig} setSelectedConfig={setSelectedConfig} handleSave={handleSave} handleSaveEnable={handleSaveEnable} originalRouterConfig={originalRouterConfig} ethernetIndexes={ethernetIndexes} setEthernetIndexes={setEthernetIndexes} newConfig={newConfig}/>

                    <DeleteWANProfileModal
                        open={confirmDelete}
                        onClose={() => { setConfirmDelete(false)}}
                        onConfirm={() => { 
                            handleRemoveServiceLine(selectedTrml)
                        }}
                        title={"Remove"}
                        confirmText={"Remove"}
                        entityLabel={`Are you sure you want to remove starlink ?`}
                        entityName=""
                        errorMessage={"This will remove starlink from this service line."}
                    />
                     <RebootTerminalDialog
                        open={confirmReboot}
                        onClose={() => setConfirmReboot(false)}
                        title="Reboot"
                        onConfirm={(notes) => handleRebootTerminal(selectedTrml, notes)}
                    />
                    <AddEditInterfaceModal
                        open={openAddToServiceLinePopup}
                        onClose={()=>{setOpenAddToServiceLinePopup(false)}}
                        onSave={() => { selectedTerminals?.accountNumber === serviceLineToUpdate?.accountNumber ?  handleAddUserTerminal() : setAddTerminalDialog(true) }}
                        title="ADD STARLINK(S) TO Service Line"
                        saveText="Add Starlinks"
                        disableSave={selectedTerminals === null}
                        layout={layout}
                      />
                      <DeleteWANProfileModal
                        open={addTerminalDialog}
                        onClose={() => { setAddTerminalDialog(false)}}
                        onConfirm={() => { 
                            handleAddUserTerminal()
                        }}
                        title={"Move Terminal"}
                        confirmText={`Following Terminals will be moved from ${selectedTerminals?.accountNumber} to ${serviceLineToUpdate?.accountNumber}`}
                        warningMessage='This may incur charges.'
                        entityLabel={`Are you sure you want to move starlink to account ${serviceLineToUpdate?.accountNumber} ?`}
                        entityName=""
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    starlinkAdmin: state.starlinkAdmin,
    authReducer: state.authReducer,
    routersOnTerminal: state.starlinkAdmin.routersOnTerminal,
    servicelineTerminalRouters: state.starlinkAdmin.servicelineTerminalRouters,
    gettingServicelineTerminalRouter: state.starlinkAdmin.gettingServicelineTerminalRouter,
    gettingTerminalRouter: state.starlinkAdmin.gettingTerminalRouter,
    applyRouterConfig: state?.starlinkAdmin?.applyRouterConfig,
    updatingRouterConfig: state?.starlinkAdmin?.updatingRouterConfig,
    routerConfig: state?.starlinkAdmin?.routerConfig,
    routerConfigs: state?.starlinkAdmin?.routerConfigs,
    rebootUserTerminal: state.starlinkAdmin.rebootUserTerminal,
    addUserTerminalToServiceLine: state.starlinkAdmin.addUserTerminalToServiceLine,
    removeUserTerminalFromServiceLine: state.starlinkAdmin.removeUserTerminalFromServiceLine,
    rebootRouter: state?.starlinkAdmin?.rebootRouter,
    routerConfigurationUpdate: state?.starlinkAdmin?.routerConfigurationUpdate,
    routerConfigAssign: state?.starlinkAdmin?.routerConfigAssign,
    createNewRouterConfig: state?.starlinkAdmin?.createNewRouterConfig,
    routerConfigVisibility: state?.starlinkAdmin?.routerConfigVisibility
});

export default withRouter(
    connect(mapStateToProps, { getStarlinkTerminalRouter, updateRouterConfig, getRouterConfig, getRouterConfigs, getServicelineTerminalRouter, addTerminalToServiceLine, removeTerminalFromServiceLine, rebootTerminal, getRebootRouter, assignRouterConfig, validateRouterConfig, updateRouterConfiguration, createRouterConfig, getRouterConfigVisibility })(DevicesTab)

);
